import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from "../../environments/environment";
import { AuthGuard } from '../guards/auth.guard';
import { fades } from './routes.animation';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule),
    data: {
      animation: fades,
      title: 'Login'
    },
  },
  {
    path: 'login/:userName',
    loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule),
    data: {
      animation: fades,
      title: 'Login'
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {
      animation: fades,
      title: 'Dashboard'
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'managedashboard',
    loadChildren: () => import('../pages/dashboard/manage-dashboard/manage-dashboard.module').then(m => m.ManageDashboardModule),
    data: {
      animation: fades,
      title: 'Gestione dashboard'
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'accountSettings',
    loadChildren: () => import('../pages/account-settings/account-settings.module').then(m => m.AccountSettingsModule),
    data: {
      animation: fades,
      title: 'Impostazioni account'
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'userInfo',
    loadChildren: () => import('../pages/user-info/user-info.module').then(m => m.UserInfoModule),
    data: {
      animation: fades,
      title: 'Informazioni utente'
    },
    canActivate: [AuthGuard]
  },

  // Comunica deep-link: catches /comunica/{any-sub-path} for email navigation
  {
    path: 'comunica',
    children: [{
      path: '**',
      loadComponent: () => import('../pages/i-frame/i-frame.component').then(m => m.IFrameComponent),
      data: { appKey: 'comunica' }
    }],
    data: { animation: fades },
    canActivate: [AuthGuard]
  },

  {
    path: ':appid/app/:id',
    loadChildren: () => import('../pages/i-frame/i-frame.module').then(m => m.IFrameModule),
    data: {
      animation: fades
    },
    canActivate: [AuthGuard]
  },

  {
    path: 'app/:id',
    loadChildren: () => import('../pages/i-frame/i-frame.module').then(m => m.IFrameModule),
    data: {
      animation: fades
    },
    canActivate: [AuthGuard]
  },

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: "**", redirectTo: "dashboard" },

]

@NgModule({
  imports: [RouterModule.forRoot(routes, environment.routes.config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
